import { useEffect, useState } from "react";
import Select from "react-select";
import { fetchCategoryLists } from "../../services/categories";

function CategorySelect(props) {
  const { inputName, onChangeCategoryOption, selectedValues, isMultiple } =
    props;
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  useEffect(() => {
    const _fetchCategoryLists = async () => {
      await fetchCategoryLists()
        .then((response) => {
          const { data } = response;
          if (data.data.categories) {
            const _options = [];
            const _selectedOptions = [];
            data.data.categories.forEach((v) => {
              _options.push({
                value: v["id"],
                label: v["name"],
              });
              if (selectedValues.includes(v["id"])) {
                _selectedOptions.push({
                  value: v["id"],
                  label: v["name"],
                });
              }
            });
            setCategoryOptions(_options);
            if (_selectedOptions.length) {
              setSelectedOptions(_selectedOptions);
            }
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };
    _fetchCategoryLists();
  }, []);
  return (
    <Select
      isMulti={isMultiple}
      name={inputName}
      options={categoryOptions}
      value={selectedOptions}
      onChange={(e) => {
        if (selectedOptions) {
          setSelectedOptions(e);
        }
        if (onChangeCategoryOption) {
          const _selectedOptions = [];
          e.forEach((v) => {
            _selectedOptions.push(v["value"]);
          });
          onChangeCategoryOption(_selectedOptions);
        }
      }}
    />
  );
}

CategorySelect.defaultProps = {
  inputName: "category_id",
  onChangeCategoryOption: null,
  selectedValues: [],
  isMultiple: false,
};

export default CategorySelect;
